import styled from 'styled-components'

export const GeneralContainer = styled.div`
  padding-top: 32px;
  margin-top: 70px;
  width: 100%;
  max-width: 980px;
`

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100%;
  flex-direction: column;
  align-items: center;
  background: var(--naval);
  overflow-x: auto;
  justify-content: space-between;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  padding: 24px 26px;
  box-shadow: var(--shadow);
  margin-bottom: 32px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  > nav {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-bottom: 8px;

    > h4 {
      font-size: 30px;
      font-weight: 600;
      color: var(--white);
    }

    > p {
      font-size: 16px;
      font-weight: 400;
      color: var(--deselect);
    }
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 125px;
    background-color: var(--primary);
    color: white;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    padding: 8px;
    height: 40px;
    font-weight: 500;
    transition: 0.2s ease;

    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }

    &:hover {
      -webkit-filter: brightness(0.9);
      filter: brightness(0.9);
    }
  }
`
